// extracted by mini-css-extract-plugin
module.exports = {"section":"ReportsPage_section__BK1Tx","flex":"ReportsPage_flex__3NSZY"};